import { render } from "./InfoCustomer.vue?vue&type=template&id=ac26f1c4"
import script from "./InfoCustomer.vue?vue&type=script&lang=js"
export * from "./InfoCustomer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__